import React, { useState, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { RiMailLine, RiLockLine } from "react-icons/ri";
import logo from "../../images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import "./index.css";
import Backdrop from "@mui/material/Backdrop";
import CSVReader from "react-csv-reader";
import { useEffect } from "react";
import Table from "react-bootstrap/Table";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import {
  collection,
  onSnapshot,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import ReactToPrint from "react-to-print";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import "react-dropdown/style.css";
import {
  Button,
  Container,
  Row,
  Col,
  Dropdown,
  DropdownButton,
  Card,
  Alert,
  Modal,
} from "react-bootstrap";
import ReactLoading from "react-loading";
import db from "../../firebase";
import { ComponentToPrint } from "./print/index";
import { useReactToPrint } from "react-to-print";
import { detectOverflow } from "@popperjs/core";
import NavbarPag from "../../components/NavbarPag";
import { useData } from "../../contexts/DataContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
export type Crypto = {
  name: string;
};
export type order = {
  alto: string;
  ancho: string;
  bultos: string;
  ciudad: string;
  contacto: string;
  destinatario: string;
  direccion: string;
  email: string;
  guia: string;
  kilos: string;
  largo: string;
  observaciones: string;
  fecha: string;
  uuid: number;
};

let Search = (): any => {
  const { rutInit } = useData();
  const navigate = useNavigate();
  useEffect(() => {
    if (rutInit === "") {
      navigate("/");
    }
  }, []);

  const [showPass, setShowPass] = useState(false);
  const [email, setEmail] = useState("");
  const [initdata, setInitdata] = useState(false);
  const [password, setPassword] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [orders, setOrders] = useState<any[]>([]);
  const [ordersToday, setOrdersToday] = useState<any[]>([]);

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [erroMsg, setErrorMsg] = useState("Faltan datos obligatorios");
  const [loading, setLoading] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [table, setTable] = useState(false);
  const location = useLocation();
  const [cryptos, setCryptos] = useState<Crypto[] | null>([
    { name: "selecciona fecha" },
  ]);
  const [selected, setSelected] = useState<Crypto>();
  const [setaInit, setInit] = useState(false);
  const [colDefs, setColDefs] = useState([
    { field: "Id" },
    { field: "Guia" },
    { field: "Destinatario" },
    { field: "Direccion" },
    { field: "Ciudad" },
    { field: "Contacto" },
    { field: "Bultos" },
    { field: "Kilos" },
    { field: "Alto" },
    { field: "Ancho" },
    { field: "Largo" },
    { field: "Observaciones" },
  ]);
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [filteredCryptos, setFilteredCryptos] = useState<Crypto[] | null>(null);

  const pdfPie = (doc: jsPDF, bultosTotal: number) => {
    doc.text("Total Bultos : " + bultosTotal, 10, 740);
    doc.text("_______________________", 40, 800);
    doc.text("_______________________", 380, 800);
    doc.text("Persona que genera manifiesto", 38, 820);
    doc.text("Persona que transporta carga", 380, 820);
  };

  const pdfTitle = (
    doc: jsPDF,
    logo: string,
    location: any,
    selected: Crypto
  ) => {
    doc.addImage(logo, "PNG", 500, -1, 100, 100);
    doc.setFontSize(20);
    doc.text("MANIFIESTO DE CARGA ", 220, 40);
    doc.setFontSize(17);
    doc.text("CLIENTE:", 10, 80);
    doc.text(location.state.name, 80, 80);
    doc.setFontSize(20);
    doc.text(selected.name, 170, 60);
    doc.text("GUIA", 10, 100);
    doc.text("OD", 80, 100);
    doc.text("CIUDAD", 160, 100);
    doc.text("DESTINO", 230, 100);
    doc.text("DIRECCION", 320, 100);
    doc.text("BULTOS", 450, 100);
    doc.text("KILOS", 550, 100);
  };

  const pdfLine = (doc: jsPDF) => {
    doc.text(
      "____________________________________________________________________________",
      0,
      105
    );
    doc.text(
      "____________________________________________________________________________",
      0,
      720
    );
  };

  const pdf = () => {
    if (selected !== undefined) {
      //--------------------XLSC--------------------------------
      //console.log("ordersToday:", ordersToday);
      const data = [
        [
          "GUIA",
          "OD",
          "CLIENTE",
          "CIUDAD",
          "DESTINO",
          "DIRECCION",
          "BULTOS",
          "KILOS",
          "CENTRO DE COSTOS",
          "OBSERVACIONES",
        ],
      ];
      ordersToday.forEach((e) => {
        // console.log("orders", e);
        data.push([
          e.guia,
          e.uuid,
          e.client,
          e.ciudad,
          e.destinatario,
          e.direccion,
          e.bultos,
          e.kilos,
          e.Centro_de_costos,
          e.observaciones,
        ]);
      });
      const ordersTodayNew: any[] = [];
      ordersToday.forEach((e) => {
        console.log(e);
        console.log(e.destinatario.length);

        console.log(e.direccion.length);
        const corteDestinatario = [];
        if (e.destinatario.length > 10) {
          let num = 0;
          while (num < e.destinatario.length) {
            num += 10;
            corteDestinatario.push(e.destinatario.slice(num - 10, num));
          }
        }
        const corteDireccion = [];
        if (e.direccion.length > 10) {
          let num = 0;
          while (num < e.direccion.length) {
            num += 15;
            corteDireccion.push(e.direccion.slice(num - 15, num));
          }
        }
        const numFor =
          corteDestinatario.length > corteDireccion.length
            ? corteDestinatario.length
            : corteDireccion.length;
        if (numFor === 0) {
          ordersTodayNew.push(e);
        } else {
          for (let i = 0; i < numFor; i++) {
            let direccion =
              corteDireccion.length > i
                ? corteDireccion[i]
                : i === 0
                  ? e.direccion
                  : "";
            let destinatario =
              corteDestinatario.length > i
                ? corteDestinatario[i]
                : i === 0
                  ? e.destinatario
                  : "";
            let data = {
              Centro_de_costos: e.Centro_de_costos,
              Destino: e.Destino,
              alto: e.alto,
              ancho: e.ancho,
              bultos: i === 0 ? e.bultos : "",
              ciudad: i === 0 ? e.ciudad : "",
              client: e.client,
              contacto: e.contacto,
              destinatario: destinatario,
              direccion: direccion,
              email: e.email,
              fecha: e.fecha,
              guia: i === 0 ? e.guia : "",
              id: e.id,
              kilos: i === 0 ? e.kilos : "",
              largo: e.largo,
              observaciones: e.largo,
              time: e.time,
              uuid: e.uuid,
            };
            ordersTodayNew.push(data);
          }
        }
        console.log("corteDestinatario", corteDestinatario);
        console.log("corteDireccion", corteDireccion);
      });
      console.log("ordersTodayNew::::", ordersTodayNew);
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, selected.name + ".xlsx");
      //------------------PDF------------------------------------
      let doc = new jsPDF("portrait", "px", "a3", false);

      pdfTitle(doc, logo, location, selected);

      pdfLine(doc);

      let bultosTotal = 0;
      ordersToday.forEach((order: order, index) => {
        bultosTotal += Number(order.bultos);
      });
      ordersTodayNew.forEach((order: order, index) => {
        if (index < 30) {
          doc.text(order.guia, 0, 130 + index * 20);
          doc.text(order.uuid.toString(), 80, 130 + index * 20);
          doc.text(order.ciudad.slice(0, 8), 160, 130 + index * 20);
          doc.text(order.destinatario.slice(0, 10), 230, 130 + index * 20);
          doc.text(order.direccion.slice(0, 17), 320, 130 + index * 20);
          doc.text(order.bultos, 450, 130 + index * 20);
          doc.text(order.kilos, 550, 130 + index * 20);
        } else {
          if (index % 30 === 0 && index !== 0) {
            pdfPie(doc, bultosTotal);
            doc.addPage();

            pdfTitle(doc, logo, location, selected);

            pdfLine(doc);

            pdfPie(doc, bultosTotal);
          }

          doc.text(order.guia, 0, 130 + (index % 30) * 20);
          doc.text(order.uuid.toString(), 80, 130 + (index % 30) * 20);
          doc.text(order.ciudad.slice(0, 8), 160, 130 + (index % 30) * 20);
          doc.text(
            order.destinatario.slice(0, 10),
            230,
            130 + (index % 30) * 20
          );
          doc.text(order.direccion.slice(0, 17), 320, 130 + (index % 30) * 20);
          doc.text(order.bultos, 450, 130 + (index % 30) * 20);
          doc.text(order.kilos, 550, 130 + (index % 30) * 20);
        }
      });
      if (ordersToday.length < 30) {
        pdfPie(doc, bultosTotal);
      }
      doc.save(selected.name + ".pdf");
    }
  };

  const loadOrders = async () => {
    //console.log("selected", selected?.name);
    //console.log("location", location.state);
    if (selected?.name === undefined) {
      return;
    }

    const partes = selected?.name.match(
      /(\d+) DE (\w+) DE (\d+), (\d+):(\d+):(\d+)/
    );

    const dia = parseInt(partes![1], 10);
    const mesTexto = partes![2].toLowerCase();
    const año = parseInt(partes![3], 10);
    const meses: Record<string, number> = {
      enero: 0,
      febrero: 1,
      marzo: 2,
      abril: 3,
      mayo: 4,
      junio: 5,
      julio: 6,
      agosto: 7,
      septiembre: 8,
      octubre: 9,
      noviembre: 10,
      diciembre: 11,
    };
    const mesNu: number = meses[mesTexto];

    const fecha = new Date(año, mesNu, dia, 0, 0, 0);
    const fecha2 = new Date(año, mesNu, dia, 23, 59, 59);
    let arrayAux: any[] = [];
    let arrayAuxToday: any[] = [];

    const q = query(
      collection(db, "orders"),
      where("email", "==", location.state.email),
      where("fecha", "==", selected?.name)
    );
    //console.log("today:", selected?.name);
    const qt = query(
      collection(db, "orders"),
      where("email", "==", location.state.email),
      where("time", ">=", fecha),
      where("time", "<=", fecha2)
    );

    const querySnapshot = await getDocs(q);
    // console.log('querySnapshot:',querySnapshot)
    const querySnapshotoday = await getDocs(qt);
    //console.log(querySnapshotoday);
    const infoToday: any = [];

    const info: any = [];
    querySnapshot.forEach((doc) => {
      info.push({ data: doc.data() });
    });
    querySnapshotoday.forEach((doc) => {
      infoToday.push({ data: doc.data() });
    });
    //console.log(infoToday);
    for (let i = 0; i < info.length; i++) {
      arrayAux.push({ ...info[i].data, client: location.state.name });
    }
    for (let i = 0; i < infoToday.length; i++) {
      arrayAuxToday.push({ ...infoToday[i].data, client: location.state.name });
    }
    /*
    info.map((doc: any) => {
      
    });*/
    //console.log("aux", arrayAux);
    arrayAux.sort((a, b) => (a.id > b.id ? 1 : -1));
    arrayAuxToday.sort((a, b) => (a.id > b.id ? 1 : -1));

    //console.log("arrayAux:", arrayAux);
    setOrders(arrayAux);
    setOrdersToday(arrayAuxToday);
  };

  useEffect(() => {
    const getDate = async () => {
      const q = query(
        collection(db, "ordersxusers"),
        where("email", "==", location.state.email)
      );
      const querySnapshot = await getDocs(q);
      let auxarray: Crypto[] = [{ name: "selecciona fecha" }];
      querySnapshot.forEach((doc) => {
        auxarray.push({ name: doc.data().fecha });
      });
      //console.log(auxarray);
      setCryptos(auxarray);
    };
    getDate();
    /***************************************************** */
  }, []);

  useEffect(() => {
    if (!initdata && cryptos !== null && selected?.name !== undefined) {
      setInitdata(true);
      if (location.state.day) {
        // console.log("location.state.day::", location.state.day);
        filterFun(location.state.day);
        loadOrders();
      }
    }
  }, [selected]);

  useEffect(() => {
    setStartDate(new Date());
    filterCryptosByDate(new Date());
  }, [cryptos]);

  const componentRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);

  const [loadings, setLoadings] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const handleAfterPrint = React.useCallback(() => {
    //console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    //console.log("`onBeforePrint` called");
  }, []);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);
  const handleOnBeforeGetContent = React.useCallback(() => {
    //console.log("`onBeforeGetContent` called");
    setLoadings(true);
    setText("Loading new text...");

    return new Promise((resolve: any) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadings(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setLoadings, setText]);

  useEffect(() => {
    if (
      text === "New, Updated Text!" &&
      typeof onBeforeGetContentResolve.current === "function" &&
      (onBeforeGetContentResolve !== null ||
        onBeforeGetContentResolve["current"] !== null)
    ) {
      const aux: any = onBeforeGetContentResolve["current"];
      aux();
    }
  }, [onBeforeGetContentResolve.current, text]);
  const reactToPrintTrigger = React.useCallback(() => {
    if (rutInit === "") {
      return <div></div>;
    }
    return (
      <button
        className=" bg-sky-600 text-white py-2 px-4 rounded-lg w-32 "
        style={{ marginLeft: 600 }}
      >
        Imprimir
      </button>
    );
  }, []);

  // Función para filtrar las fechas
  const filterCryptosByDate = (date: Date | null) => {
    //console.log("filterCryptosByDate", date);
    //console.log("cryptos:", cryptos);
    if (!date || !cryptos) {
      setFilteredCryptos(null); // Si no hay fecha, no aplicar filtro
      return;
    }

    // Formatear la fecha seleccionada para compararla con las de cryptos
    const selectedDate = date.toLocaleDateString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const filtered = cryptos.filter((crypto) =>
      crypto.name.startsWith(selectedDate.toUpperCase())
    );

    setFilteredCryptos(filtered);
    //console.log("filtered", filtered);
    if (setaInit === false && filtered.length > 0) {
      //const [setaInit, setInit] = useState(false);
      setInit(true);
      //console.log("filtered************", filtered.length);
      setSelected(filtered[0]);
    }
  };

  const filterFun = (value: string) => {
    const c = cryptos?.find((x) => x.name === value) as Crypto;
    setSelected(c);
  };

  useEffect(() => {
    if (setaInit === false) filterCryptosByDate(startDate);
  }, [setaInit]);

  return (
    <div>
      <div className="w-screen  bg-[#FFFFFF] overflow-hidden">
        {/* navbar */}
        <NavbarPag />
        <div className="h grid grid-cols-6  content-start mt-10">
          <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-6">Carga de CSV y Filtros</h1>

            {/* Sección: Fecha y hora de carga */}
            <article>
              <div className="flex p-4">
                <div className="pr-7 pl-7">
                  <label>Selecciona la fecha y hora de carga CSV:</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => {
                      setInit(false);
                      // console.log(date);
                      setStartDate(date);
                      filterCryptosByDate(date); // Filtrar al seleccionar una fecha
                    }}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Selecciona una fecha"
                    className="border border-gray-300 rounded-lg p-2  "
                  />
                </div>

                {/* Sección: Filtrar por fechas */}
                <div className="pr-7 pt-4 ">
                  <label className="block text-lg font-medium mb-2 w-96">
                    Filtrar por fechas:
                  </label>
                  <select
                    onChange={(e) => {
                      // console.log("dfsd:;;", e.target.value);
                      //console.log(typeof e.target.value);
                      filterFun(e.target.value);
                    }}
                    defaultValue="default"
                    value={selected?.name}
                    className="border border-gray-300 rounded-lg p-2 w-96"
                  >
                    {(filteredCryptos || cryptos || []).map((crypto, index) => (
                      <option key={index} value={crypto.name}>
                        {crypto.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Botón: Cargar Etiquetas */}
                <div className="text-right pt-12 ">
                  <button
                    className="bg-sky-600 text-white py-2 w-60 px-4 rounded-lg hover:bg-sky-700 transition"
                    onClick={loadOrders}
                  >
                    Cargar Etiquetas
                  </button>
                </div>
              </div>
            </article>
          </div>
          <div>
            {orders.length > 0 && (
              <button
                className=" bg-sky-600 text-white py-2 px-4 rounded-lg"
                onClick={pdf}
              >
                Descargar manifiesto
              </button>
            )}
          </div>
        </div>
        <div className="h grid grid-cols-1  content-start mt-10">
          {orders.length > 0 && componentRef && (
            <>
              {" "}
              <ReactToPrint
                content={reactToPrintContent}
                documentTitle="AwesomeFileName"
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint
                trigger={reactToPrintTrigger}
              />
              {loadings && <p className="indicator ml-6">Loading...</p>}
              <ComponentToPrint {...orders} ref={componentRef} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default Search;
